import {
    getAdminUserListEndpoint,
    getAssociatedAccountListEndpoint,
    getUserRoleEndpoint,
    getARDTlistEndpoint,
    getAssociatedPhysicianListEndpoint,
    getAssociatedZGPhysicianListEndpoint,
    getNewAssignmentEndpoint,
    updateUserEndpoint,
    addProxyEndpoint,
    updateProxyEndpoint,
    revokeProxyEndpoint,
    getProxyListEndpoint,
    getAdminProxyUserListEndpoint,
    getFilterDetailsEndpoint,
} from 'src/pages/admin/redux/services/endpoints.js';
import axios from 'src/api/Api';

export const getAdminUserListService = async (params) => {
    const response = await axios.get(getAdminUserListEndpoint(params));
    return response ? response.data : {};
};

export const getAssociatedAccountListService = async (params) => {
    const response = await axios.get(
        getAssociatedAccountListEndpoint(params)
    );
    return response ? response.data : {};
};

export const addProxiesService = async (queryParams) => {
    const response = await axios.post(addProxyEndpoint(queryParams));
    return response ? response.data : {};
};

export const getAssociatedPhysicianListService = async (param) => {
    let response;
    if(param.salesOrg === 'JP' || param.countryISOCode === 'S024'){
        response = await axios.get(
            getAssociatedZGPhysicianListEndpoint(param)
        );
    }else{
        response = await axios.get(
            getAssociatedPhysicianListEndpoint(param)
        );
    }
    
    return response ? response.data : {};
};

export const updateProxiesService = async (queryParams) => {
    const response = await axios.post(updateProxyEndpoint(queryParams));
    return response ? response.data : {};
};

export const getUserRoleService = async () => {
    const response = await axios.get(getUserRoleEndpoint());
    return response ? response.data : {};
};

export const revokeProxiesService = async (queryParams) => {
    const response = await axios.delete(revokeProxyEndpoint(queryParams));
    return response ? response.data : {};
};
export const getARDTService = async (params) => {
    const response = await axios.get(getARDTlistEndpoint(params));
    return response ? response.data : {};
};

export const getProxyListService = async (params) => {
    const response = await axios.get(getProxyListEndpoint(params));
    return response ? response.data : {};
};
export const getNewAssignmentService = async (params) => {
    const response = await axios.get(getNewAssignmentEndpoint(params));

    return response ? response.data : {};
};

export const updateUserService = async (params) => {
    const response = await axios.put(updateUserEndpoint(), {
        ...params.payload,
    });

    return response ? response.data : {};
};

export const getAdminProxyUserListService = async (param) => {
    const response = await axios.get(getAdminProxyUserListEndpoint(param));

    return response ? response.data : {};
};

export const getFilterDetailsService = async (urlValue, param) => {
    const response = await axios.get(
        getFilterDetailsEndpoint(urlValue, param)
    );

    return response ? response.data : {};
};
